var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-expandable-content',{ref:"dropdown",class:_vm.contentClasses,attrs:{"id":_vm.dropdownId,"open":_vm.isOpen,"contentId":_vm.contentId}},[_c('ui-layout',{class:`dropdown__panel dropdown__panel--height-${_vm.height}`,attrs:{"gap":"0","align":"start","direction":"column","justify":"start"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }